<script lang="ts">
import FicheChecksEmis from '@/generated/fiches/FicheChecksEmis.vue';
import { defineComponent } from "vue";

export default defineComponent({
  components: {},
  extends: FicheChecksEmis
})

</script>
